import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

const MenuWrapper = styled.div`
    position: fixed;
    top: 5rem;
    left: 1rem;
    width: fit-content;
    background-color: white;
    border-radius: 0.15rem
    padding: 0.125rem 0.125rem;
    box-shadow: 0.5rem 0.5rem 1.0rem #f4f4f4;
    z-index: 100;
    border: 0.15rem solid #ececec;
    border-radius: 0.25rem;
`;

const MenuOption = styled.div`
    padding: 0.25rem 1rem;
    margin: 0.25rem 0.5rem;
    color: #bbbbbb;
    cursor: pointer;
    &:hover {
        background-color: #f4f4f4;
        color: #444444;
    }
`;

const MenuOptionText = styled.div`
    font-size: 1.25rem;
    font-style: italic;
    &:hover {
        text-decoration: underline;
    }
`;

const OptionDisabled = styled.div`
    padding: 0.25rem 0.5rem;
    margin: 0.25rem 0.25rem;
`;

const OptionDisabledText = styled.div`
    font-size: 1.25rem;
    font-style: italic;
    color: #222222;
    margin-left: 0.5rem;
    display: inline-block;
`;

const Dot = styled.div`
    display: inline-block;
    background-color: black;
    border-radius: 0.125rem;
    height: 0.25rem;
    width: 0.25rem;    
    vertical-align: top;
    margin-top: 0.5rem;
`;

export class WebPageMenu extends Component {

    static propTypes = {
        options: PropTypes.array.isRequired,
        on_menu_select: PropTypes.func.isRequired,
    }

    render() {
        const options = this.props.options.map(option => {
            return !option.selectable ?
                <OptionDisabled key={option.section}>
                    <Dot/>
                    <OptionDisabledText>{option.title}</OptionDisabledText>
                </OptionDisabled> :
                <MenuOption key={option.section} onClick={e => this.props.on_menu_select(option.section)}>
                    <MenuOptionText>{option.title}</MenuOptionText>
                </MenuOption>
        });
        return <MenuWrapper>
            {options}
        </MenuWrapper>
    }
}

export default WebPageMenu;
